import React from "react";
import { TableRow, TableCell, Chip, useTheme, IconButton } from "@mui/material";
import DialogComponent from "../../dialog/Dialog.component";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { useTranslation } from "react-i18next";

const SUPERUSER = "superuser";

const UserRow = ({
  item,
  onEditClick = () => { },
  onDeleteClick = () => { },
  typeUser,
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  return (
    <TableRow >
      <TableCell align="left">{item?.email}</TableCell>
      <TableCell align="left">{item?.firstName}</TableCell>
      <TableCell align="left">{item?.lastName}</TableCell>
      <TableCell align="left">
        {item?.enabled ? (
          <Chip
            label={t('Enabled')}
            size="small"
            sx={{
              border: `1px solid ${theme.palette.mode === "dark"
                ? theme.palette.success.light + 60
                : theme.palette.success.light + 60
                }`,
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.success.light + 60,
              color: theme.palette.success.dark,
            }}
          />
        ) : (
          <Chip
            label={t('Not Enabled')}
            size="small"
            sx={{
              border: `1px solid ${theme.palette.mode === "dark"
                ? theme.palette.success.light + 60
                : theme.palette.success.light + 60
                }`,
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.orange.light + 80,
              color: theme.palette.orange.dark,
            }}
          />
        )}
      </TableCell>
      <TableCell align="left">
        {item?.confirmed ? (
          <Chip
            label={t('Confirmed')}
            sx={{
              border: `1px solid ${theme.palette.mode === "dark"
                ? theme.palette.success.light + 60
                : theme.palette.success.light + 60
                }`,
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.success.light + 60,
              color: theme.palette.success.dark,
            }}
            size="small"
          />
        ) : (
          <Chip
            label={t('Not confirmed')}
            sx={{
              border: `1px solid ${theme.palette.mode === "dark"
                ? theme.palette.success.light + 60
                : theme.palette.success.light + 60
                }`,
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.orange.light + 80,
            }}
            size="small"
          />
        )}
      </TableCell>
      <TableCell align="left">
        <Chip label={item?.role} size="small" />
      </TableCell>

      {typeUser === SUPERUSER && (
        <TableCell
          align="right"
          onClick={onEditClick}
          sx={{ cursor: "pointer" }}
        >
          <IconButton size="large">
            <EditTwoToneIcon
              sx={{
                fontSize: "1.3rem",
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.main
                    : theme.palette.primary.main,
              }}
            />
          </IconButton>
        </TableCell>
      )}
      {typeUser === SUPERUSER && (
        <TableCell align="right" sx={{ cursor: "pointer" }}>
          <DialogComponent
            content={t('Are you sure you want to proceed with the deletion?')}

            button={
              <IconButton size="large">
                <DeleteTwoToneIcon
                  sx={{
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.secondary.main
                        : theme.palette.secondary.main,
                  }}
                />
              </IconButton>
            }
            onClickYes={onDeleteClick}
          />
        </TableCell>
      )}
    </TableRow>
  );
};

export default UserRow;
